import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyvfUiModule } from '@myvf/ui';
import { StickyComponent } from './sticky/sticky.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, MyvfUiModule, FormsModule],
  declarations: [StickyComponent],
  exports: [StickyComponent],
})
export class StickyModule {}
